import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";
import useScrollToTop from "../../hooks/useScrollToTop";
import WhatsAppFloat from "../shared/WhatsAppFloat";

const pageVariants = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: { duration: 0.4, ease: [0, 0, 0.2, 1] },
    },
    exit: {
        opacity: 0,
        transition: { duration: 0.2 },
    },
};

function LoadingFallback() {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
        </div>
    );
}

export default function Layout({ children }) {
    const location = useLocation();
    useScrollToTop();

    return (
        <div className="min-h-screen bg-surface-base flex flex-col">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-brand-500 focus:text-white focus:outline-none"
            >
                Skip to content
            </a>
            
            <Header />
            
            <Suspense fallback={<LoadingFallback />}>
                <AnimatePresence mode="wait">
                    <motion.main
                        id="main-content"
                        key={location.pathname}
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        className="flex-1 pt-20"
                    >
                        {children}
                    </motion.main>
                </AnimatePresence>
            </Suspense>
            
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}
